import React from 'react';
import { Grid, Col, Row } from '@bit/knotchinc.web-react-components.grid';
import SummaryTile from '@bit/knotchinc.web-react-components.tiles.summary-tile';
import { numberWithCommas, formatterWithWord, formatTime } from 'helpers/Utils.js';
import { SectionTitle } from 'components/Global/Title/Title.jsx';

const RowWrap = componentArray => componentArray.map((cols, i) => <Row key={`stats-row-${i}`}>{cols}</Row>);


const ContentStatsRow = (props) => {
  const { entitiesList, content } = props;
  const multiEntity = entitiesList.length > 1;

  const AvgReadingTime = entitiesList.map(({ public_id }) => (
    <Col centered key={`col-content-read-time-${public_id}`}>
      <SectionTitle>Content Avg Reading Time</SectionTitle>
      <SummaryTile data={formatTime(content[public_id].data.avg_read_time)} isVerticallyAligned />
    </Col>
  ));

  const AvgArticleLength = entitiesList.map(({ public_id }) => (
    <Col centered key={`col-article-length-${public_id}`}>
      <SectionTitle>Average Length of Article</SectionTitle>
      <SummaryTile data={content[public_id].data.avg_num_words} formatter={formatterWithWord('Words', numberWithCommas)} isVerticallyAligned />
    </Col>
  ));

  const Shares = entitiesList.map(({ public_id }) => (
    <Col centered key={`col-shares-${public_id}`}>
      <SectionTitle>Shares</SectionTitle>
      <SummaryTile data={content[public_id].data.num_shares} formatter={formatterWithWord('Shares', numberWithCommas)} isVerticallyAligned />
    </Col>
  ));

  const componentArray = [
    AvgReadingTime,
    AvgArticleLength,
    Shares,
  ];

  return multiEntity ? <Grid height={702}>{RowWrap(componentArray)}</Grid> : <Grid height={234}>{componentArray}</Grid>;
};

export default ContentStatsRow;

